export default "__VITE_ASSET__OS_PODu1__"